import { setWebNotificationStatus } from "../../reducers/User/action";

export const BlockInvalidNumber = ( e ) => {
    ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
}

export const BlockSQLInjection = ( e ) => {
    ['<', '>'].includes(e.key) && e.preventDefault()
}

export const HtmlTagValidation = ( value ) => {
    let status = true;
    let tagValidate =/<(.|\n)*?>/g; 

    if ( tagValidate.test(value) ) {
        status = false;
    }

    return status;
}

// Business List Module Enhancement v1.1 - Requirement 1: duplicate business check.
// Replaces the old Address1 + City comparison with Business Name + Address 1 + State,
// shared across Admin Add/Edit Shop, Stylist (My Business) Add/Edit Shop, and AddShopWizard
// so the three screens stay in sync instead of drifting with their own copies.
export const DUPLICATE_SHOP_MESSAGE = 'Business name already exists with same state.';
export const DUPLICATE_SHOP_HELPER_MESSAGE = 'Duplicate state found.';

// excludeShopId lets Edit Shop skip comparing the record against itself.
export const checkDuplicateShop = (shopList, values, excludeShopId) => {
    if (!Array.isArray(shopList)) return false;
    return shopList.some(shop =>
        shop.id !== excludeShopId &&
        shop.name && values.name &&
        shop.name.trim().toLowerCase() === values.name.trim().toLowerCase() &&
        shop.address1 && values.address1 &&
        shop.address1.trim().toLowerCase() === values.address1.trim().toLowerCase() &&
        shop.stateProvinceId != null && values.stateProvinceId != null &&
        shop.stateProvinceId === values.stateProvinceId
    );
};

// Business List Module Enhancement v1.1 - Requirement 2: standardized business display
// format everywhere a business appears in a dropdown/list. Old format was "Name (Address1)";
// new format is "Name, Address1, State". stateNameById is a { stateId: stateName } lookup
// built by the caller from whatever state list it already has on hand.
// NOTE: the shop list API doesn't send stateProvinceId per shop yet, so this falls back to
// "Name, Address1" (no crash/"undefined") until backend adds that field - revisit once it does.
export const formatShopLabel = (shop, stateNameById = {}) => {
    if (!shop) return '';
    const parts = [shop.name];
    if (shop.address1) parts.push(shop.address1);
    // Prefer shop.state (the real state name string some endpoints - like postShopList -
    // now send directly) over the stateProvinceId lookup, which not every endpoint returns.
    const stateName = shop.state || (shop.stateProvinceId != null ? stateNameById[shop.stateProvinceId] : null);
    if (stateName) parts.push(stateName);
    return parts.join(', ');
};

// Business List Module Enhancement v1.1 - Requirement 3: backend contract for the Shop
// Creation API (Admin Add Shop / Stylist Add Shop / AddShopWizard all share this shape).
// - managerFirstName/managerLastName/managerPhoneNumber must be sent as null (not "") when
//   "Are you the owner?" = No, per the backend team's example payload.
// - OwnedBy is always sent as 0 in the request regardless of the Yes/No answer - the backend
//   derives the real owner server-side from isOwnership + createdBy, it isn't computed here.
// Only applies to shop CREATE calls; no contract has been shared yet for shop update.
export const buildShopCreatePayload = (values) => ({
    ...values,
    managerFirstName: values.isOwnership === 'Y' ? values.managerFirstName : null,
    managerLastName: values.isOwnership === 'Y' ? values.managerLastName : null,
    managerPhoneNumber: values.isOwnership === 'Y' ? values.managerPhoneNumber : null,
    OwnedBy: 0
});

// Business List Module Enhancement v1.1 - Requirement 3: backend contract for the Shop
// UPDATE API (Edit Shop, Admin + Stylist both share this shape). Unlike the create payload:
// - No createdBy, no active, no OwnedBy field at all - editing never touches ownership.
// - Only the exact fields below are sent, matching the backend's given example precisely.
// managerFirstName/managerLastName/managerPhoneNumber are set to null when "Are you the
// owner?" = No, same rule as create - the backend team's example only showed the Yes case,
// but the requirement text says "ownership rules are preserved," so this assumes it's the
// same rule. Flag/revisit if backend confirms otherwise.
export const buildShopUpdatePayload = (values) => ({
    shopId: values.shopId,
    name: values.name,
    managerFirstName: values.isOwnership === 'Y' ? values.managerFirstName : null,
    managerLastName: values.isOwnership === 'Y' ? values.managerLastName : null,
    managerPhoneNumber: values.isOwnership === 'Y' ? values.managerPhoneNumber : null,
    countryId: values.countryId,
    stateProvinceId: values.stateProvinceId,
    city: values.city,
    address1: values.address1,
    address2: values.address2,
    zipCode: values.zipCode,
    phoneNumber: values.phoneNumber,
    isOwnership: values.isOwnership
});

export const checkConfirmBooking = (e) => {
    const tooltipElement = e.appointments;
    
    setTimeout(() => {
        const listItems = document.querySelectorAll('.dx-list-item');
        listItems.forEach((data, index) => {
            let elementdata = tooltipElement[index].appointmentData;

            if ( elementdata.status == 'Completed' || elementdata.status == 'NoShow' ) {
                data.classList.add('completedBookingCalendar');
            }

        });
    }, 100);
    
};

export const bookingcalendarListColor = [
    {
        text : 'completedBooking',
        id : 1,
        color : '#008000'
    }, 
    {
        text : 'selfBooking',
        id : 2,
        color : '#6c757d'
    }, 
    {
        text : 'upcommingBokking',
        id : 3,
        color : '#ff5200'
    }
]



export const requestNotificationPermission = async (dispatch, webNotificationStatus) => {
    if (webNotificationStatus) {
        return;
    }

    if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
        dispatch(setWebNotificationStatus(true));
        return;
    }

    const permission = await Notification.requestPermission();
    dispatch(setWebNotificationStatus(true));

    if (permission === "granted") {
    } else {
        alert("Notification permission denied.");
    }
};

export const showNotification = (title, options = {}) => {
  
    const fallbackNotify = () => {
        new Notification(title, {
            body: options.body || "This is a notification",
            icon: "https://unextpro.com/images/notification.png",
            ...options
        });
    };
  
    const withTimeout = (promise, timeoutMs) => {
        return Promise.race([
            promise,
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error("ServiceWorker.ready timed out")), timeoutMs)
            )
        ]);
    };
  
    if ('serviceWorker' in navigator) {
  
      withTimeout(navigator.serviceWorker.ready, 3000) // timeout after 1.5s
        .then(registration => {
            registration.showNotification(title, {
                body: options.body || "This is a notification",
                icon: "https://unextpro.com/images/notification.png",
                ...options
            });
        })
        .catch(err => {
            console.warn('Service worker not ready in time or failed:', err.message);
            fallbackNotify();
        });
    } else {
        fallbackNotify();
    }
};

export const getTimeZoneName = ( fullName ) => {

    let updatedName = '';

    if ( fullName ) {
        let splitName = fullName.split(' ');

        if ( splitName[0] == 'US/Alaska' ) {
            updatedName = 'America/Anchorage';
        } else if ( splitName[0] == 'US/Arizona' ) {
            updatedName = 'America/Phoenix';
        } else if ( splitName[0] == 'US/Central' ) {
            updatedName = 'America/Chicago';
        } else if ( splitName[0] == 'US/Eastern' ) {
            updatedName = 'America/New_York';
        } else if ( splitName[0] == 'US/Hawaii' ) {
            updatedName = 'Pacific/Honolulu';
        } else if ( splitName[0] == 'US/Mountain' ) {
            updatedName = 'America/Denver';
        } else if ( splitName[0] == 'US/Pacific' ) {
            updatedName = 'America/Los_Angeles';
        }
    } 

    return updatedName;
}
  
  